// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f9eb9b79","450":"0501ce95","455":"a943752d","488":"69fc52ba","645":"a03ce225","911":"340d88a2","977":"a31c1f33"}[chunkId] + ".chunk.js";
};